import React, {FC} from 'react';
import styled from 'styled-components';
import {UnstyledLink} from '../UnstyledLink/UnstyledLink';

export const BannerFlexLink: FC<React.PropsWithChildren<{to: string}>> = ({
  children,
  to,
  ...props
}) => {
  return (
    <FlexLink to={to} {...props} aria-label={undefined}>
      {children}
    </FlexLink>
  );
};

const FlexLink = styled(UnstyledLink)`
  display: flex;
  flex-direction: column;
`;
